import type { FC } from "react";

import styled from "@emotion/styled";
import translate from "src/lib/translate";
import { IconChevronDownLine } from "src/ui/assets/icons/IconChevronDownLine";

import { formatMealTakenAt } from "./mealInsightHelpers";

const TextButton = styled.button`
  align-self: flex-start;
  display: flex;
  align-items: center;
  gap: 0.25rem;
  height: 1.5rem;
  margin: 0;
  padding: 0;
  border: none;
  background: none;
  color: inherit;
  font-family: var(--font-family);
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.375rem;
  letter-spacing: -0.32px;
  white-space: nowrap;
  cursor: pointer;

  svg {
    width: 1.25rem;
    height: 1.25rem;
  }
`;

interface MealTakenAtButtonProps {
  takenAt: string;
  onPress: () => void;
}

const MealTakenAtButton: FC<MealTakenAtButtonProps> = ({
  takenAt,
  onPress
}) => {
  const label = formatMealTakenAt(takenAt);

  return (
    <TextButton
      type="button"
      onClick={onPress}
      aria-label={translate("mealInsights.takenAt.edit", { date: label })}
    >
      {label}
      <IconChevronDownLine aria-hidden />
    </TextButton>
  );
};

export default MealTakenAtButton;
